import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCategoryState } from "@insite/client-framework/Store/Data/Categories/CategoriesSelectors";
import Typography from "@insite/mobius/Typography";
import Card from "@midland-industries/Components/Card";
import Stack from "@midland-industries/Components/Stack";
import Clickable from "@midland-industries/MobiusOverrides/Clickable/Clickable";
import React, { useState } from "react";
import { connect } from "react-redux";

interface CategoryCardProps {
    categoryId: string;
}

const mapStateToProps = (state: ApplicationState, ownProps: { categoryId: string }) => ({
    category: getCategoryState(state, ownProps.categoryId).value,
});

type Props = CategoryCardProps & ReturnType<typeof mapStateToProps>;

const CategoryCard: React.FC<Props> = ({ category }) => {
    const [hover, setHover] = useState(false);
    const { path, shortDescription, smallImagePath } = category || {};

    return category ? (
        <Card
            width={172}
            height={183}
            cardStyles={{
                transition: "box-shadow 0.35s ease",
                boxShadow: hover
                    ? "0px 3px 10px 0px rgba(122, 122, 125, 0.15)"
                    : "0px 3px 5px 0px rgba(122, 122, 125, 0.15)",
            }}
        >
            <Clickable href={path} onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
                <Stack align="center" gap={10}>
                    <div
                        style={{
                            width: 171,
                            height: 124,
                            backgroundImage: `url(${smallImagePath})`,
                            backgroundSize: "cover",
                            borderRadius: "20px 20px 0 0",
                        }}
                    />
                    <Stack justify="center" style={{ height: 47 }}>
                        <Typography
                            style={{ width: 154, textAlign: "center" }}
                            weight={700}
                            size={16}
                            lineHeight="18px"
                        >
                            {shortDescription}
                        </Typography>
                    </Stack>
                </Stack>
            </Clickable>
        </Card>
    ) : (
        <></>
    );
};

export default connect(mapStateToProps)(CategoryCard);
